import { SecondaryButton } from '@/app/components/SecondaryButton'
import { Headline6 } from '@/app/components/Typography'
import { ExpandWindow } from '@/app/icons/ExpandWindow'
import { WEBSITE_LINKS } from '@/app/lib/constants'
import React from 'react'
import { useIntl } from 'react-intl'

type SignUpBenefitsProps = React.HTMLAttributes<HTMLDivElement>

export function SignUpBenefits(props: SignUpBenefitsProps) {
  const intl = useIntl()

  const benefitKeys = ['catalogue', 'payment_options', 'career_paths'] as const

  return (
    <aside
      {...props}
      className={`flex flex-col gap-5 p-4 text-white text-left rounded-2xl ${props.className ?? ''}`}
    >
      <Headline6 className="!text-lg !font-sans font-semibold">
        {intl.formatMessage({
          id: 'SignUpBenefits.headline',
          defaultMessage: 'Unlock your potential',
        })}
      </Headline6>
      <ul className="flex flex-col gap-4 font-normal">
        {benefitKeys.map((key) => (
          <li
            className="list-none relative pl-8 before:bg-contain before:content-[''] before:inline-block before:absolute before:left-0 before:top-1/2 before:-translate-y-full before:h-5 before:object-scale-down before:w-5 before:bg-[url(/images/sf-check.png)]"
            key={key}
          >
            {intl.formatMessage({
              id: `SignUpBenefits.benefits.${key}`,
              defaultMessage: key,
            })}
          </li>
        ))}
      </ul>
      <hr />

      <p className="font-title md:text-xl">
        {intl.formatMessage({
          id: 'SignUpBenefits.summary',
          defaultMessage: 'Start your learning journey today',
        })}
      </p>
      <SecondaryButton
        variant="gray"
        className="self-start bg-white"
        href={WEBSITE_LINKS.mydraWebsite}
        target="_blank"
      >
        <div className="flex gap-2 items-center text-sm">
          {intl.formatMessage({
            id: 'SignUpBenefits.learn_more',
            defaultMessage: 'Learn more',
          })}
          <ExpandWindow className="w-4 h-4" />
        </div>
      </SecondaryButton>
    </aside>
  )
}
